export const publicKey = process.env.REACT_APP_PUBLIC_KEY;
export const privateKey = process.env.REACT_APP_PRIVATE_KEY;